/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/refundOrderManageOld',
    component: Layout,
    meta: {
      title: '退款订单列表',
      icon: 'component',
    },
    children: [
      {
        path: '/refundOrderManageOld/refundOrderList',
        component: () => import('@/myviews/refundOrderManageOld/refundOrderList'),
        name: 'refundOrderOldList',
        meta: {
          title: '退款订单列表',
          icon: 'component',
          roles: [],
          have: [],
        }
      },
      {
        path: '/refundOrderManageOld/refundOrderDetail',
        component: () => import('@/myviews/refundOrderManageOld/refundOrderDetail'),
        name: 'refundOrderOldDetail',
        hidden: true,
        meta: {
          title: '退款订单详情',
          icon: 'component',
          roles: [],
          have: [],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/refundOrderManageOld.js